<template>
    <div>
        <el-row style="margin-bottom: 16px;">
            <div style="width:20%;display: inline-block;">
                <el-input v-model="searchKey" placeholder="关键字" @change="getDatas">
                    <el-button slot="append" icon="el-icon-search"></el-button>
                </el-input>
            </div>
            <el-button type="primary" plain @click="outportInfo" style="float: right;"> 导出</el-button>

        </el-row>
        <el-table
           :data="listData"
            border
            highlight-current-row
            :header-cell-style="{background:'#a6aeb7',color:'#000'}"
            row-key="guid"
            :span-method="objectSpanMethod"
            @current-change="changeRow"
            @selection-change="handleSelectionChange">
            <el-table-column align="center" label="公司" prop="company"></el-table-column>
            <el-table-column align="center" label="地址" prop="address"></el-table-column>
            <el-table-column align="center" label="测试人员" prop="testPeople"></el-table-column>
            <el-table-column align="center" label="电话号码" prop="phone"></el-table-column>
            <el-table-column align="center" label="环境名称" prop="environmentName"></el-table-column>
            <el-table-column align="center" label="relay名称" prop="relayName"></el-table-column>
            <el-table-column align="center" label="上行延时" prop="uplinkDelay"></el-table-column>
            <el-table-column align="center" label="下行延时" prop="downwardDelay"></el-table-column>
            <el-table-column align="center" label="上行带宽" prop="uplinkBandwidth"></el-table-column>
            <el-table-column align="center" label="下行带宽" prop="downlinkBandwidth"></el-table-column>
            <el-table-column align="center" label="上行丢包" prop="uplinkPacketLoss"></el-table-column>
            <el-table-column align="center" label="下行丢包" prop="downlinkPacketLoss"></el-table-column>
        </el-table>

        <el-pagination
            class="fy"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10,20,30,40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElement"
            >
        </el-pagination>
    </div>
</template>
<script>
import { Loading } from "element-ui";
export default {
    name:'WebDetect',
    data: vm=>({
        spanArr: [],
        pos: 0,
        listData: [],
        searchKey: null, //搜索关键字
        time: '',
        currentPage: 1,
        pageSize: 10,
        totalElement: 0,
        checkedRows: [],
    }),
    computed: {
        condition(){
            let obj = {
                detectkw: this.searchKey ? this.searchKey : "",
                pageNo: this.currentPage,
                pageSize: this.pageSize
            }

            return obj
        },
    },
    created(){
        // 当前时间和当前时间往前推3小时
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 3);
        this.time = [new Date(start).getTime(), new Date(end).getTime()]
        this.getDatas()

    },
    methods: {
        handleSelectionChange(val){
            this.checkedRows = val
        },
        getSpanArr(data) {　
          for (var i = 0; i < data.length; i++) {
            if (i === 0) {
              this.spanArr.push(1);
              this.pos = 0
            } else {
              // 判断当前元素与上一个元素是否相同
            if (data[i].company === data[i - 1].company &&
            data[i].address === data[i - 1].address &&
            data[i].testPeople === data[i - 1].testPeople &&
            data[i].phone === data[i - 1].phone &&
            data[i].environmentName === data[i - 1].environmentName) {
                this.spanArr[this.pos] += 1;
                this.spanArr.push(0);
              } else {
                this.spanArr.push(1);
                this.pos = i;
              }
            }
            // console.log(this.spanArr)
        }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
          if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4) {
            const _row = this.spanArr[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            // console.log(`rowspan:${_row} colspan:${_col}`)
            return { // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                  rowspan: _row,
                  colspan: _col
            }
          }
        },
        // 导出
        outportInfo(){
            let url = this.detectApiUrl + "jk/detectwebApi/exportExcel"
            // console.log(url)
            window.location.href = url

        },
        changeRow(row){
            this.$emit('clickRow', row)
        },
        // 探测事件列表
        getDatas(){
            this.spanArr = []
            this.pos = 0
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.$axios
                .post(
                this.detectApiUrl +
                    "jk/detectwebApi/getdetect", this.condition
                )
                .then(({ data: { msg, data, code } }) => {
                    if (code == 0) {
                        this.listData = data.detectInfoList;
                        this.getSpanArr(this.listData)
                        this.totalElement = data.totalSize
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        // console.log(msg);
                    }
                    loading.close();
                })
                .catch(error => {
                    loading.close();
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        handleSizeChange(val){
            this.pageSize = val
            this.getDatas()
        },
        handleCurrentChange(val){
            this.currentPage = val
            this.getDatas()
        },
    }
}
</script>
<style scoped>
.fy {
  text-align: right;
  margin-top: 30px;
}
.condition{
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
}
.dangerInfo{
    color: red;
}

.pickerWidth{
    width: 100% !important;
}
</style>
